import {ArrayTyper} from '@caliatys/array-typer';

export class Account {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  preferredUsername: string;
  status: string;
  imageUrl: string;
  preferences: Preferences;
  addressName: string;
  addressStreet: string;
  addressState: string;
  addressCity: string;
  addressZipCode: string;
  addressCountry: string;
  phoneMobile: string;
  phoneOffice: string;
  notificationSMS: boolean;
  notificationEmail: boolean;
  notificationPush: boolean;
  lastActivity: Date;
  totalBusinessProfile: number;
  businessProfiles: BusinessProfile[];
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;

  constructor(obj: any) {
    this.id = obj?.id;
    this.firstName = obj?.firstname;
    this.lastName = obj?.lastname;
    this.email = obj?.email;
    this.phoneNumber = obj?.phoneNumber;
    this.preferredUsername = obj?.preferredUsername;
    this.status = obj?.status;
    this.imageUrl = obj?.imageUrl;
    this.preferences = new Preferences(obj?.preferences);
    this.addressName = obj?.addressName;
    this.addressStreet = obj?.addressStreet;
    this.addressState = obj?.addressState;
    this.addressCity = obj?.addressCity;
    this.addressZipCode = obj?.addressZipCode;
    this.addressCountry = obj?.addressCountry;
    this.phoneMobile = obj?.phoneMobile;
    this.phoneOffice = obj?.phoneOffice;
    this.notificationSMS = obj?.notificationSMS;
    this.notificationEmail = obj?.notificationEmail;
    this.notificationPush = obj?.notificationPush;
    this.lastActivity = new Date(obj?.lastActivity);
    this.totalBusinessProfile = obj?.totalBusinessProfile;
    this.businessProfiles = ArrayTyper.asArray(BusinessProfile, obj?.businessProfiles);
    this.createdAt = new Date(obj?.createdAt);
    this.createdBy = obj?.createdBy;
    this.updatedAt = new Date(obj?.updatedAt);
    this.updatedBy = obj?.updatedBy;
  }
}

export class Preferences {
  mvSites: number;
  mvAssets: number;
  mvDevices: number;
  mvDeviceEvents: number;
  mvAssetEvents: number;
  appDatesFormat: string;
  appLanguage: string;
  occurrenceTime: boolean;

  constructor(obj: any) {
    this.mvSites = obj?.mvSites;
    this.mvAssets = obj?.mvAssets;
    this.mvDevices = obj?.mvDevices;
    this.mvDeviceEvents = obj?.mvDeviceEvents;
    this.mvAssetEvents = obj?.mvAssetEvents;
    this.appDatesFormat = obj?.appDatesFormat;
    this.appLanguage = obj?.appLanguage;
    this.occurrenceTime = obj?.occurrenceTime;
  }
}

export class TimezoneDetail {
  name: string;
  offset: string;
}

export class BusinessProfile {
  id: string;
  name: string;
  level: number;
  timezone: string;
  timezoneDetails: TimezoneDetail;
  entityId: string;
  entityName: string;
  tagTotal: number;
  roleTotal: number;
  userTotal: number;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  chartPeriod: number;

  constructor(obj: any) {
    this.id = obj?.id;
    this.name = obj?.name;
    this.level = obj?.level;
    this.timezone = obj?.timezone;
    this.timezoneDetails = obj?.timezoneDetails;
    this.entityId = obj?.entityId;
    this.entityName = obj?.entityName;
    this.tagTotal = obj?.tagTotal;
    this.roleTotal = obj?.roleTotal;
    this.userTotal = obj?.userTotal;
    this.createdAt = new Date(obj?.createdAt);
    this.createdBy = obj?.createdBy;
    this.updatedAt = new Date(obj?.updatedAt);
    this.updatedBy = obj?.updatedBy;
    this.chartPeriod = obj?.chartPeriod;
  }
}
